/* eslint-disable react/react-in-jsx-scope */

import { Routes, Route } from 'react-router-dom'
import Header from './components/shared/header/header'
import Footer from './components/shared/footer/footer'
import CookieWarning from './components/shared/cookieWarning/cookieWarning'
import Inicio from './components/views/inicio/inicio'
import Estrategia from './components/views/estrategiaIT/estrategia'
import Contacto from './components/views/contacto/contacto'
import Exitos from './components/views/casosExito/casosExito'
import LaEmpresa from './components/views/empresa/la-empresa'
import SoporteOperaciones from './components/views/soporteOperaciones/soporteOperaciones'
import ScrollToTop from './ScrollToTop'
import Consultoria from './components/views/consultoria/consultoria'
import Arquitectura from './components/views/arquitectura/arquitecturaSoftware'
import Desarrollo from './components/views/desarrolloSoftware/desarrolloSoftware'
import CookiePolicy from './components/views/Cookies/cookie-policy'
import ProductManagement from './components/views/gestionProductos/gestionProductos'

function App (): any {
  return (
    <div>
      <Header />
      <ScrollToTop />
      <Routes>
        <Route index element={ <Inicio /> }></Route>
        <Route path="estrategia-it" element={ <Estrategia /> }></Route>
        <Route path="arquitectura" element={ <Arquitectura /> }></Route>
        <Route path="desarrollo-software" element={ <Desarrollo /> }></Route>
        <Route path="la-empresa" element={ <LaEmpresa /> }></Route>
        <Route path="contacto" element={ <Contacto /> }></Route>
        <Route path="casos-de-exito" element={ <Exitos /> }></Route>
        <Route path="politica-cookies" element={<CookiePolicy />}></Route>
        <Route path="soporte-de-operaciones" element={ <SoporteOperaciones/> }></Route>
        <Route path="consultoria" element={<Consultoria />}></Route>
        <Route path="arquitectura" element={<Arquitectura/>}></Route>
        <Route path="gestion-de-productos" element={<ProductManagement/>}></Route>
      </Routes>
      <CookieWarning />
      <Footer />
    </div>
  )
}

export default App
